import React, { useEffect, useState } from "react";
import { MembershipAPI } from "../../api/membership";
import { useNavigate } from "react-router-dom";
import { IconButton, Stack } from "@mui/material";
import { defaultEditFormState } from "../constant";
import VisibilityIcon from "../../assets/SVGs/Login/VisibilityIcon";
import { DataGrid } from "@mui/x-data-grid";
import WeeklyMeetEditModal from "../Modal/WeeklyMeetEditModal";
import dayjs from "dayjs";

const MemeberWeeklyMeetsTab = ({ id }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openEditModal, setOpenEditModal] = useState(defaultEditFormState);

  const fetchMembers = async () => {
    setIsLoading(true);
    try {
      setData(await MembershipAPI.getMemberWeeklyMeets(id));
    } catch (e) {
      const status = e.response?.status;
      if (status === 401) {
        navigate("/login");
      }
      console.error("Error during fetching report", e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    isLoading && fetchMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, isLoading]);

  const columns = [
    {
      field: "weekly_meet_date",
      headerName: "Weekly Meet Date",
      flex: 1,
      type: "date",
      valueGetter: (params) => {
        return dayjs(params).toDate();
      },
      renderCell: (params) => {
        return params.value ? dayjs(params.value).format("MM/DD/YYYY") : "";
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          aria-label="view"
          size="small"
          onClick={() =>
            setOpenEditModal({
              open: true,
              id: params?.row?.id,
              title: params?.row?.weekly_meet_date
                ? dayjs(params?.row?.weekly_meet_date).format("MM/DD/YYYY")
                : "",
            })
          }
        >
          <VisibilityIcon
            sx={{
              color: "#64748B",
            }}
          />
        </IconButton>
      ),
    },
  ];

  return (
    <>
      <div className="sub-header">Weekly Attendance</div>
      <Stack
        sx={{
          width: "100%",
          "& .MuiDataGrid-root": {
            borderRadius: "8px",
          },
        }}
        className="customDataGridFigma"
      >
        <DataGrid
          rows={data?.items || []}
          columns={columns}
          loading={isLoading}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          checkboxSelection={false}
          rowSelection={false}
          rowHeight={48}
          columnHeaderHeight={40}
          getRowClassName={(params) => {
            const customClassName =
              params.indexRelativeToCurrentPage % 2 !== 0 ? "bg-gray" : "";
            return ` ${customClassName}`.trim();
          }}
          slotProps={{
            loadingOverlay: {
              variant: "linear-progress",
              noRowsVariant: "linear-progress",
            },
          }}
          localeText={{
            noRowsLabel: "No weekly meets found.",
          }}
        />
        {openEditModal?.open && (
          <WeeklyMeetEditModal
            open={openEditModal?.open}
            id={openEditModal?.id}
            handleClose={() => setOpenEditModal(defaultEditFormState)}
            setIsLoading={setIsLoading}
            title={openEditModal?.title}
          />
        )}
      </Stack>
    </>
  );
};

export default MemeberWeeklyMeetsTab;
